import { ApolloClient } from "apollo-client";
import { ApolloLink } from "apollo-link";
import { onError } from "apollo-link-error";
import { HttpLink } from "apollo-link-http";
import { withClientState } from "apollo-link-state";
import { InMemoryCache } from "apollo-cache-inmemory";
import { defaults, Mutation } from "./lyst-apollo";

const cache = new InMemoryCache();

const stateLink = withClientState({
    cache,
    resolvers: {
        Mutation
    },
    defaults
});

export const client = new ApolloClient({
    link: ApolloLink.from([
        onError(({ graphQLErrors, networkError }) => {
            if (graphQLErrors) {
                graphQLErrors.map(({ message, locations, path }) =>
                    console.log(
                        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
                    )
                );
            }
            if (networkError) {
                console.log(`[Network error]: ${networkError}`);
            }
        }),
        stateLink,
        new HttpLink({
            uri: "/graphql/",
            credentials: "same-origin"
        })
    ]),
    cache
});
